import { getRequest } from "../utils/functions";

export default name => {
  const request = getRequest({}, "GET");
  return fetch(`${process.env.REACT_APP_API_URL}/store/contract`, request)
    .then(res => res.blob())
    .then(file => {
      file = new Blob([file], { type: "application/pdf" });
      const url = window.URL.createObjectURL(file);
      const a = document.createElement("a");
      a.href = url;
      a.download = `contrat_${name}.pdf`.toLowerCase();
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.open(url, "_blank");
    });
};
